module.exports = __webpack_public_path__ + "img/default.8fcff9ed.svg";